export default __webpack_public_path__ + "static/media/cloudflare.831eb16e.svg";